import {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { AccountEntryService } from 'api';
import { isSuccessful } from 'api/utils';
import { StyledButton } from 'components/Buttons';
import { LoaderFullScreen } from 'components/Loaders/LoaderFullScreen';
import { useTranslation } from 'react-i18next';
import { appToast } from 'utils/toast.utils';
import * as S from '../../InvoiceAllocations.css';

type Props = {
  open: boolean;
  onClose: () => void;
  onSubmit: () => void;
  accountEntryIds: number[];
  accountEntriesLoading: boolean;
};

export const ConfirmAllocationDialog = ({
  open,
  onClose,
  onSubmit,
  accountEntryIds,
  accountEntriesLoading,
}: Props) => {
  const { t } = useTranslation(['misc']);

  const { loading, acceptAccountEntry } =
    AccountEntryService.useAcceptAccountEntry();

  const handleSubmit = async () => {
    const res = await acceptAccountEntry(accountEntryIds);
    isSuccessful(res) &&
      appToast.success(t('message.acceptSuccess', { ns: 'misc' }));
    await onSubmit();
    onClose();
  };

  const isBackdropVisible: boolean = loading || accountEntriesLoading;

  return (
    <S.StyledDialog open={open} onClose={onClose}>
      <LoaderFullScreen loading={isBackdropVisible} />
      <DialogTitle>
        {t('modal.acceptAllocationHeading', { ns: 'misc' })}
      </DialogTitle>
      <DialogContent dividers>
        <DialogContentText>
          {t('modal.acceptAllocationBody', { ns: 'misc' })}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <StyledButton $primary onClick={handleSubmit}>
          {t('button.accept', { ns: 'misc' })}
        </StyledButton>
        <StyledButton onClick={onClose}>
          {t('button.cancel', { ns: 'misc' })}
        </StyledButton>
      </DialogActions>
    </S.StyledDialog>
  );
};
